import { useEffect } from 'react';

export const useHideNavBar = () => {
    useEffect(() => {
        document.querySelector('nav[class^="OverviewNavigation_"]').style.display = 'none';
        return () => {
            document.querySelector('nav[class^="OverviewNavigation_"]').style.display = 'block';
        };
    }, []);
};

export const useHideNavBarV4 = () => {
    useEffect(() => {
        let homePage = document.querySelector('nav[class^="HomePageV4_"]');
        if(homePage){
            document.querySelector('nav[class^="HomePageV4_"]').style.display = 'none';
        }
        let twoColumn = document.querySelector('div[class^="TwoColumnScaffold__leftColumn_"]');
        if(twoColumn){
            document.querySelector('div[class^="TwoColumnScaffold__leftColumn_"]').style.display = 'none';
        }
        let footer = document.querySelector('div[class^="Tasks__footerRowContainer__"]');
        if (footer)
            document.querySelector('div[class^="Tasks__footerRowContainer__"]').style.display = 'none';
        return () => {
            document.querySelector('nav[class^="HomePageV4_"]').style.display = 'block';
            document.querySelector('div[class^="TwoColumnScaffold__leftColumn_"]').style.display = 'block';
            if (footer)
                document.querySelector('div[class^="Tasks__footerRowContainer__"]').style.display = 'block';
        };
    }, []);
};